<app-list class="type-utilization-list" [items]="typeUtilizationList">
  <ng-template listItem let-item="item">
    <div class="type-utilization-item">
      <app-check-box
        class="checkbox"
        [value]="typeUtilizationSet.has(item.value)"
        (valueChange)="onTypeUtilizationChanged(item, $event)"
        [label]="item.label"
        [disabled]="disabled"
        [readOnly]="!!readOnly"
      ></app-check-box>
    </div>
  </ng-template>
</app-list>
